// Module
var code = "<a href=\"javascript:;\" class=\"btn button-plan subFormControl\"> <i class=\"fa fa-calendar\"></i> <span><!--ko text: Label--><!--/ko--></span> </a>";
// Exports
export default code;